import Billing from '@web-solutions/module-billing';
import { isFoodzeeBackend } from '@web-solutions/react-billing';
import { init as initBilling } from '@web-solutions/core/store/billing/actions';
import { setApiAuth } from '@web-solutions/core/utils/network';
import { setAuthorized } from '@web-solutions/base-app/store/profile/actions';

import { useStore } from '../store/store';

type FoodzeeAuthPayload = {
  accessToken?: string;
  refreshToken?: string;
  uid?: string;
  user?: {
    uid?: string;
  };
};

type Options = {
  reinitBilling?: boolean;
  paymentSystem?: string;
  syncBillingAuth?: boolean;
};

export const applyFoodzeeAuthTokens = (
  payload: FoodzeeAuthPayload | undefined,
  dispatch?: any,
  options: Options = {},
) => {
  const accessToken = payload?.accessToken;

  if (!accessToken) {
    return false;
  }

  const authHeader = `Bearer ${accessToken}`;
  const userId = payload?.uid || payload?.user?.uid;
  const paymentSystem = options.paymentSystem || Billing.paymentSystemType;
  // Both Stripe and TailoredPay run against the Foodzee backend, which only
  // accepts a billing auth token issued by itself (source 'foodzee').
  const shouldSyncBillingAuth = options.syncBillingAuth ?? isFoodzeeBackend(paymentSystem);

  useStore.getState().setAuthTokens({
    accessToken,
    refreshToken: payload?.refreshToken,
    userId,
  });

  if (!shouldSyncBillingAuth) {
    return false;
  }

  Billing.setApiAuth(authHeader);
  setApiAuth(authHeader);

  if (dispatch) {
    dispatch(setAuthorized({
      token_type: 'Bearer',
      access_token: accessToken,
      source: 'foodzee',
    }));

    if (options.reinitBilling) {
      return dispatch(initBilling());
    }
  }

  return true;
};
